// 직업 상세 데이터 (평균연봉·은퇴연령은 공개 통계 기반의 참고 수치로, 시기·기관·경력에 따라 달라질 수 있음)

export interface Job {
  name: string;
  category: string;
  summary: string;
  description: string;
  salary: string;
  retirementAge: string;
  education: string;
  traits: string[];
}

export const jobs: Job[] = [
  // ─── 공공·행정·공기업 ───
  {
    name: '소방공무원',
    category: '공공·안전',
    summary: '화재 진압과 구조·구급 활동을 통해 국민의 생명과 재산을 지키는 직업',
    description: '화재 진압, 구조, 구급, 예방 활동을 담당하며 24시간 교대 근무를 한다. 체력시험과 필기·면접을 통한 경쟁시험으로 선발되며, 재난 현장의 최일선에서 일하는 직업이다. 안정적인 공무원 신분과 함께 사회적 신뢰가 높다.',
    salary: '연 4,200만~5,500만원',
    retirementAge: '약 60세 (정년)',
    education: '소방공무원 공채시험 (체력·필기·면접)',
    traits: ['체력', '책임감', '침착함', '봉사정신'],
  },
  {
    name: '경찰공무원',
    category: '공공·안전',
    summary: '국민의 생명과 재산을 보호하고 범죄를 예방·수사하는 직업',
    description: '범죄 예방과 수사, 교통 관리, 치안 유지 등을 담당한다. 순경 공채, 경찰대, 간부후보생 등 다양한 채용 경로가 있으며 순환 근무가 많다. 공무원으로서의 안정성과 함께 시민 안전을 책임지는 보람이 크다.',
    salary: '연 4,200만~5,500만원',
    retirementAge: '약 60세 (정년)',
    education: '경찰공무원 채용시험 (순경·경찰대·간부)',
    traits: ['체력', '정의감', '판단력', '인내심'],
  },
  {
    name: '외교관',
    category: '공공·행정',
    summary: '국가를 대표해 외교 정책을 수행하고 국제 협상과 교류를 담당하는 직업',
    description: '외교부에서 국가 간 관계, 국제기구 협력, 재외국민 보호, 통상 협상 등을 담당한다. 외교관후보자 시험(구 외무고시)을 통해 선발되며 해외 근무가 많다. 높은 어학 능력과 국제적 식견이 요구된다.',
    salary: '연 5,000만~9,000만원',
    retirementAge: '약 60세 (정년)',
    education: '외교관후보자 시험 합격',
    traits: ['어학능력', '교섭력', '국제감각', '논리력'],
  },
  {
    name: '공무원',
    category: '공공·행정',
    summary: '국가와 지방자치단체에서 행정·정책 업무를 수행하는 직업',
    description: '일반행정, 세무, 교육, 사회복지 등 다양한 분야에서 정책을 기획하고 민원을 처리한다. 9급 공채부터 5급(행정고시)까지 다양한 채용 경로가 있으며 정년이 보장되는 대표적인 안정 직업이다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세 (정년)',
    education: '공무원 공채시험 (9급·7급·5급)',
    traits: ['성실성', '책임감', '문서작성', '규칙준수'],
  },
  {
    name: '가스공사 직원',
    category: '공공·공기업',
    summary: '천연가스의 도입·공급과 에너지 인프라를 운영하는 공기업 직원',
    description: '한국가스공사 등 에너지 공기업에서 가스 공급, 설비 운영, 안전 관리, 신재생에너지 사업 등을 담당한다. 공기업으로서 높은 연봉과 복지, 안정성이 강점이며 관련 자격증과 전공이 유리하다.',
    salary: '연 7,000만~8,500만원',
    retirementAge: '약 60세 (정년)',
    education: '공기업 채용 (NCS·전공 필기)',
    traits: ['전문성', '안전의식', '책임감', '협업능력'],
  },
  {
    name: '환경관리공단 직원',
    category: '공공·공기업',
    summary: '환경 시설 운영과 대기·수질 관리를 담당하는 환경 공기업 직원',
    description: '한국환경공단 등에서 하수·폐수 처리, 대기·수질 측정, 환경 시설 운영, 탄소중립 사업 등을 담당한다. 환경 문제에 대한 관심과 전문성이 필요하며 공공성과 안정성을 함께 갖춘 직업이다.',
    salary: '연 5,800만~7,000만원',
    retirementAge: '약 60세 (정년)',
    education: '공기업 채용 (환경 관련 전공 유리)',
    traits: ['환경의식', '전문성', '분석력', '성실성'],
  },
  {
    name: '한국교통공사 직원',
    category: '공공·공기업',
    summary: '철도·교통 인프라의 운영과 안전 관리를 담당하는 교통 공기업 직원',
    description: '철도 운영, 역무, 교통 안전, 시설 관리 등 교통 관련 공공기관에서 일한다. 철도·교통 시스템의 안정적인 운영을 책임지며 관련 자격증(철도운송 등)을 갖추면 유리하다. 높은 안정성과 복지가 강점이다.',
    salary: '연 6,000만~7,200만원',
    retirementAge: '약 60세 (정년)',
    education: '공기업 채용 (교통·철도 전공 유리)',
    traits: ['안전의식', '책임감', '정확성', '팀워크'],
  },

  // ─── 운수·교통 ───
  {
    name: '버스기사',
    category: '운수·교통',
    summary: '시내·시외·고속버스를 운행하며 승객을 안전하게 수송하는 직업',
    description: '정해진 노선과 시간표에 따라 버스를 운행하며 승객 안전과 서비스를 책임진다. 대형면허와 운전 경력이 필요하며 장거리 운행과 교대 근무가 잦다. 경력이 쌓일수록 임금과 안정성이 높아진다.',
    salary: '연 3,500만~4,800만원',
    retirementAge: '약 55~60세',
    education: '대형(1종) 운전면허',
    traits: ['운전능력', '책임감', '친절함', '체력'],
  },
  {
    name: '택시기사',
    category: '운수·교통',
    summary: '택시를 운행하며 승객을 목적지까지 수송하는 직업',
    description: '일반·모범·개인택시 등 형태가 다양하며, 개인택시의 경우 사납금 없이 수입을 온전히 가져갈 수 있다. 운전면허 취득 후 일정 기간 무사고 경력이 필요하며 정년 제한 없이 오래 일할 수 있는 직업이다.',
    salary: '연 2,600만~3,500만원',
    retirementAge: '약 65세 이상 (정년 없음)',
    education: '택시운전자격 + 운전 경력',
    traits: ['운전능력', '친절함', '인내심', '자기관리'],
  },
  {
    name: '철도기관사',
    category: '운수·교통',
    summary: '전철·고속열차 등 철도 차량을 운전하고 안전하게 운행하는 직업',
    description: 'KORAIL이나 도시철도공사 등에서 열차를 운전하며 안전 운행과 승객 보호를 책임진다. 철도 관련 자격과 신체검사, 집중력이 필수이며 높은 안정성과 임금을 갖춘 전문 직업이다.',
    salary: '연 5,500만~6,800만원',
    retirementAge: '약 60세 (정년)',
    education: '철도운전면허 (기능·필기시험)',
    traits: ['집중력', '책임감', '침착함', '정확성'],
  },
  {
    name: '항공기 기장',
    category: '운수·교통',
    summary: '항공기의 최종 책임자로서 비행을 총괄하고 승객을 안전하게 수송하는 직업',
    description: '부기장으로 경력을 쌓은 뒤 승격하며, 비행 전체의 안전과 의사결정을 책임진다. 수천 시간의 비행 경력과 면장, 신체검사가 필요하며 최상위 전문직으로 높은 연봉과 명예를 갖는다. 장기간의 훈련과 비용이 요구된다.',
    salary: '연 1억~1억 6,000만원',
    retirementAge: '약 65세 (정년)',
    education: '항공기 면장 + 비행 경력',
    traits: ['판단력', '책임감', '침착함', '리더십'],
  },
  {
    name: '승무원',
    category: '운수·교통',
    summary: '항공기에서 승객의 안전과 서비스를 담당하는 객실 승무원',
    description: '안전 관리, 기내 서비스, 응급 대처 등을 담당하며 체력과 외국어 능력이 중요하다. 대형 항공사 채용 경쟁이 치열하며 국제선 비행과 불규칙한 스케줄이 특징이다. 비교적 이른 나이에 정년·전직하는 경우가 많다.',
    salary: '연 3,800만~5,500만원',
    retirementAge: '약 45~55세',
    education: '항공사 채용 (어학·신체조건)',
    traits: ['서비스마인드', '어학능력', '체력', '친화력'],
  },

  // ─── 서비스·외식·판매 ───
  {
    name: '바리스타',
    category: '서비스·외식',
    summary: '커피를 전문적으로 추출하고 고객에게 음료와 서비스를 제공하는 직업',
    description: '원두 관리, 추출, 음료 제조, 고객 응대를 담당한다. 바리스타 자격증과 실무 경력을 통해 스페셜티 커피 전문가나 카페 창업으로 성장할 수 있다. 진입 장벽은 낮지만 전문성을 쌓으면 경쟁력이 높아진다.',
    salary: '연 2,400만~3,200만원',
    retirementAge: '약 40~50대',
    education: '바리스타 자격증 (2급·1급)',
    traits: ['감각적 취향', '서비스마인드', '꼼꼼함', '친화력'],
  },
  {
    name: '제빵사',
    category: '서비스·외식',
    summary: '빵과 디저트를 전문적으로 만드는 기술직',
    description: '반죽, 발효, 굽기 등 제빵 전 과정을 담당하며 제과·제빵기능사 자격증이 기본이다. 베이커리, 호텔, 제과점 등에서 일하며 숙련도에 따라 연봉이 오르고, 장인으로서 독립 창업도 가능하다.',
    salary: '연 2,700만~3,600만원',
    retirementAge: '약 50대',
    education: '제과·제빵기능사 자격증',
    traits: ['손재주', '인내심', '성실성', '감각'],
  },
  {
    name: '요리사',
    category: '서비스·외식',
    summary: '한식·양식·일식·중식 등 다양한 요리를 전문적으로 조리하는 직업',
    description: '재료 손질부터 조리, 플레이팅까지 담당하며 한식조리기능사 등 자격증이 도움이 된다. 호텔, 레스토랑, 급식 등에서 일하며 수석 주방장으로 성장하거나 자신의 식당을 창업할 수 있다.',
    salary: '연 2,800만~3,800만원',
    retirementAge: '약 50대',
    education: '조리기능사 자격증',
    traits: ['손재주', '창의성', '체력', '인내심'],
  },
  {
    name: '판매업 종사자',
    category: '서비스·판매',
    summary: '상품을 소개하고 고객과 소통하며 판매를 담당하는 직업',
    description: '백화점, 대형마트, 편의점, 전문 매장 등에서 상품 진열과 고객 응대, 판매를 담당한다. 의류·전자·명품 등 분야에 따라 전문성이 커지며, 영업·MD·매장 관리자로 성장할 수 있다.',
    salary: '연 2,400만~3,400만원',
    retirementAge: '약 50대',
    education: '특별한 자격 불요 (분야별 교육)',
    traits: ['소통능력', '친화력', '설득력', '서비스마인드'],
  },

  // ─── 보건·의료 ───
  {
    name: '물리치료사',
    category: '보건·의료',
    summary: '운동·물리적 방법으로 환자의 신체 기능 회복을 돕는 의료기사',
    description: '근골격계 질환, 신경계 손상, 재활 치료 등을 담당하며 병원, 재활센터, 스포츠의학센터 등에서 일한다. 물리치료사 면허 취득이 필수이며 고령화로 수요가 꾸준히 증가하는 직업이다.',
    salary: '연 3,500만~4,600만원',
    retirementAge: '약 60세',
    education: '물리치료사 면허 (대학 졸업)',
    traits: ['공감능력', '체력', '손기술', '배려심'],
  },
  {
    name: '간호사',
    category: '보건·의료',
    summary: '환자의 간호와 건강 관리를 담당하는 전문 의료인',
    description: '병원, 보건소, 산업체 등에서 환자 간호, 건강 관리, 응급 대응을 담당한다. 간호사 면허 취득이 필수이며 3교대 근무가 일반적이다. 진출 분야가 넓고 안정성이 높은 전문직이다.',
    salary: '연 4,000만~5,000만원',
    retirementAge: '약 55~60세',
    education: '간호사 면허 (간호학과 졸업)',
    traits: ['배려심', '체력', '침착함', '책임감'],
  },
  {
    name: '의사',
    category: '보건·의료',
    summary: '질병을 진단하고 치료하는 최고 수준의 전문 의료인',
    description: '의과대학 졸업 후 국가고시와 전문의 과정(인턴·레지던트)을 거쳐 진료한다. 내과·외과·정신과 등 전문 분야가 다양하며 높은 사회적 지위와 연봉을 갖지만, 수련 기간이 길고 책임이 막중하다.',
    salary: '연 1억 5,000만~3억원',
    retirementAge: '약 65세 이상',
    education: '의사 면허 + 전문의 과정',
    traits: ['전문성', '책임감', '판단력', '배려심'],
  },
  {
    name: '약사',
    category: '보건·의료',
    summary: '의약품의 조제·관리와 복약 지도를 담당하는 전문 의료인',
    description: '약국, 병원, 제약회사 등에서 의약품 조제, 복약 지도, 약물 관리 등을 담당한다. 약학대학 6년 과정과 약사 면허 취득이 필요하며 안정성과 전문성이 높은 직업이다.',
    salary: '연 6,000만~8,000만원',
    retirementAge: '약 65세',
    education: '약사 면허 (약학대학 졸업)',
    traits: ['꼼꼼함', '전문성', '책임감', '정확성'],
  },
  {
    name: '수의사',
    category: '보건·의료',
    summary: '동물의 질병을 진단하고 치료하는 전문 의료인',
    description: '반려동물 진료, 가축 방역, 식품 안전, 동물 보호 등 다양한 분야에서 일한다. 수의대 졸업과 수의사 면허 취득이 필요하며 반려동물 인구 증가로 수요가 늘고 있다.',
    salary: '연 5,000만~7,000만원',
    retirementAge: '약 65세',
    education: '수의사 면허 (수의대 졸업)',
    traits: ['동물애호', '손기술', '관찰력', '책임감'],
  },

  // ─── 예술·문화 ───
  {
    name: '학예사',
    category: '예술·문화',
    summary: '박물관·미술관에서 소장품의 연구·기획·전시를 담당하는 전문직',
    description: '큐레이터라고도 불리며 소장품 연구, 전시 기획, 도록 제작, 교육 프로그램 운영 등을 담당한다. 관련 전공과 학예사 자격증이 필요하며, 공립 박물관·미술관은 경쟁이 치열하다. 문화에 대한 깊은 이해와 기획력이 요구된다.',
    salary: '연 3,500만~4,800만원',
    retirementAge: '약 60세',
    education: '학예사 자격증 + 관련 전공',
    traits: ['심미안', '기획력', '연구능력', '소통능력'],
  },
  {
    name: '미술관 관리자',
    category: '예술·문화',
    summary: '미술관의 전시·소장품·시설을 총괄 운영하는 관리자',
    description: '전시 기획, 소장품 보존, 예산·인력 관리, 대외 협력 등을 총괄한다. 학예사로 경력을 쌓은 뒤 승진하거나 미술행정을 전공하는 경우가 많다. 예술에 대한 식견과 조직 운영 능력을 함께 갖춰야 한다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '학예사 자격 + 미술행정 경력',
    traits: ['리더십', '심미안', '기획력', '조직관리'],
  },
  {
    name: '박물관 관리자',
    category: '예술·문화',
    summary: '박물관의 소장품·전시·교육 프로그램을 총괄 운영하는 관리자',
    description: '소장품 보존, 전시 기획, 교육 프로그램, 인력과 예산 관리 등을 담당한다. 학예사 경력과 박물관학 전공이 유리하며 역사·문화 콘텐츠에 대한 깊은 이해가 필요하다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '학예사 자격 + 박물관학 전공',
    traits: ['기획력', '연구능력', '리더십', '보존의식'],
  },
  {
    name: '박물관 안내사',
    category: '예술·문화',
    summary: '관람객에게 전시와 소장품을 설명하고 안내하는 문화 해설 전문가',
    description: '도슨트라고도 불리며 전시 해설, 관람 안내, 교육 프로그램 진행을 담당한다. 역사·미술·문화에 대한 지식과 뛰어난 전달력이 필요하며, 프리랜서나 파트타임으로 활동하는 경우도 많다.',
    salary: '연 2,400만~3,200만원',
    retirementAge: '약 55~60세',
    education: '도슨트 양성 과정 + 문화 관련 지식',
    traits: ['전달력', '친화력', '표현력', '교양'],
  },
  {
    name: '미술치료사',
    category: '예술·문화',
    summary: '미술 활동을 통해 심리적 치유와 정서적 안정을 돕는 전문가',
    description: '미술 매체를 활용해 내담자의 감정 표현과 심리 치유를 돕는다. 미술치료 관련 학위와 자격이 필요하며 병원, 상담센터, 복지기관 등에서 활동한다. 예술과 심리학을 결합한 융합 직업이다.',
    salary: '연 3,500만~4,500만원',
    retirementAge: '약 60세',
    education: '미술치료 관련 학위 + 자격',
    traits: ['공감능력', '창의성', '경청능력', '인내심'],
  },

  // ─── 기술·기능 ───
  {
    name: '환경미화원',
    category: '기술·기능',
    summary: '도시의 청결을 유지하고 생활 폐기물을 수거·처리하는 직업',
    description: '도로 청소, 생활 쓰레기 수거, 재활용 분리 등을 담당하며 지방자치단체의 공무직으로 채용되는 경우가 많다. 체력이 필요하지만 정년이 보장되고 안정적인 편이며, 지역사회에 필수적인 공공 서비스를 제공한다.',
    salary: '연 2,800만~3,500만원',
    retirementAge: '약 60세 (정년)',
    education: '공무직 채용 (특별 자격 불요)',
    traits: ['체력', '성실성', '책임감', '인내심'],
  },
  {
    name: '자동차정비원',
    category: '기술·기능',
    summary: '자동차의 고장 진단과 정비·수리를 담당하는 기술직',
    description: '엔진, 브레이크, 전장 등 자동차 전반의 점검과 정비를 담당한다. 자동차정비기능사 자격증이 기본이며, 전기차·하이브리드 확산으로 전장 정비 전문가의 수요가 늘고 있다. 숙련될수록 기술력이 곧 경쟁력이다.',
    salary: '연 3,000만~4,500만원',
    retirementAge: '약 55~60세',
    education: '자동차정비기능사 자격증',
    traits: ['손기술', '문제해결', '꼼꼼함', '체력'],
  },
  {
    name: '전기기사',
    category: '기술·기능',
    summary: '전기 설비의 설계·시공·유지보수를 담당하는 전문 기술직',
    description: '건물·공장·발전소 등의 전기 설비 설계, 시공, 안전 관리를 담당한다. 전기기사 자격증이 필수이며 국가기술자격 중에서도 활용도와 안정성이 높다. 전기차·신재생에너지 분야로도 확장 가능하다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '전기기사 자격증',
    traits: ['전문성', '안전의식', '정확성', '책임감'],
  },

  // ─── 스포츠 ───
  {
    name: '운동선수',
    category: '스포츠',
    summary: '특정 종목에서 기량을 겨루는 전문 스포츠 선수',
    description: '야구, 축구, 농구, 골프 등 종목별로 실업팀·프로팀에 소속되어 경기에 출전한다. 어릴 때부터 집중적인 훈련이 필요하며 인기 종목일수록 높은 연봉을 받지만 선수 생명이 짧고 부상 위험이 크다.',
    salary: '연 수천만~수십억원 (종목·인기에 따라 극심한 편차)',
    retirementAge: '약 20대 후반~30대 초반',
    education: '종목별 선수 등록·팀 소속',
    traits: ['체력', '승부욕', '집중력', '인내심'],
  },
  {
    name: '운동선수 매니저',
    category: '스포츠',
    summary: '선수의 계약·일정·이미지 관리를 전담하는 에이전트',
    description: '선수의 이적·연봉 계약, 스폰서십, 일정과 미디어 관리를 담당한다. 스포츠 산업에 대한 이해와 협상력, 인맥이 중요하며 스포츠 에이전트 자격이 도움이 된다. 스포츠 산업이 커지며 전문 인력 수요가 늘고 있다.',
    salary: '연 4,000만~7,000만원',
    retirementAge: '약 60세',
    education: '스포츠에이전트 자격 + 관련 전공',
    traits: ['협상력', '소통능력', '기획력', '신뢰성'],
  },
  {
    name: '스포츠코치',
    category: '스포츠',
    summary: '선수와 팀의 기량 향상을 위해 훈련을 지도하는 전문가',
    description: '기술 지도, 체력 훈련, 전술 분석, 선수 관리 등을 담당한다. 학교, 실업팀, 프로팀, 개인 레슨 등 활동 범위가 넓으며 해당 종목의 선수 경력과 지도자 자격이 유리하다.',
    salary: '연 3,500만~5,000만원',
    retirementAge: '약 60세',
    education: '스포츠지도사 자격 + 선수 경력',
    traits: ['지도력', '소통능력', '분석력', '리더십'],
  },
  {
    name: '운동처방사',
    category: '스포츠',
    summary: '개인의 건강 상태에 맞는 운동 프로그램을 설계·처방하는 전문가',
    description: '체력 측정과 건강 상태 분석을 바탕으로 맞춤 운동을 처방한다. 보건소, 스포츠센터, 재활기관 등에서 일하며 운동생리학·스포츠과학 지식과 관련 자격이 필요하다.',
    salary: '연 3,500만~4,500만원',
    retirementAge: '약 60세',
    education: '운동처방 관련 학위 + 자격',
    traits: ['전문성', '분석력', '소통능력', '배려심'],
  },

  // ─── 통번역·언어 ───
  {
    name: '통역사',
    category: '통번역·언어',
    summary: '서로 다른 언어를 사용하는 사람들 사이에서 의미를 전달하는 전문가',
    description: '회의, 협상, 국제행사 등에서 순차·동시통역을 담당한다. 뛰어난 어학 능력과 함께 순발력, 문화적 이해가 필수적이며 프리랜서로 활동하는 경우가 많다. 전문 분야(의료·법률·기술) 통역은 더 높은 수입을 기대할 수 있다.',
    salary: '연 3,500만~7,000만원',
    retirementAge: '약 60세 (프리랜서는 자유)',
    education: '통번역 관련 전공 + 고급 어학 능력',
    traits: ['어학능력', '순발력', '집중력', '문화이해'],
  },
  {
    name: '동시통역사',
    category: '통번역·언어',
    summary: '국제회의에서 실시간으로 통역하는 최상위 통역 전문가',
    description: '부스에서 헤드폰을 끼고 연사의 말을 실시간으로 통역한다. 극도로 높은 집중력과 어학 능력이 요구되며 국제기구·대형 컨퍼런스에서 활동한다. 통역사 중에서도 최상위 직군으로 높은 수입을 기대할 수 있다.',
    salary: '연 6,000만~1억원',
    retirementAge: '약 60세 (프리랜서는 자유)',
    education: '통번역대학원 졸업 + 전문 통역 경력',
    traits: ['초고도 집중력', '어학능력', '순발력', '침착함'],
  },
  {
    name: '번역가',
    category: '통번역·언어',
    summary: '문서·도서·영상 등의 텍스트를 다른 언어로 옮기는 전문가',
    description: '출판, 영상, 웹툰, 기술 문서 등 다양한 분야의 번역을 담당한다. 정확한 언어 구사와 전문 분야 지식이 필요하며 프리랜서로 활동하는 경우가 많다. 번역 업계의 디지털화와 웹툰·웹소설 해외 진출로 수요가 증가하고 있다.',
    salary: '연 3,000만~5,000만원',
    retirementAge: '약 60세 (프리랜서는 자유)',
    education: '번역 관련 전공 + 전문 분야 지식',
    traits: ['언어감각', '꼼꼼함', '집중력', '인내심'],
  },

  // ─── 미디어·창작 ───
  {
    name: '기자',
    category: '미디어·창작',
    summary: '사회의 주요 사건과 이슈를 취재하고 보도하는 언론인',
    description: '신문·방송·온라인 매체에서 취재, 기사 작성, 보도를 담당한다. 정확성과 윤리의식, 빠른 판단력이 중요하며 사회의 감시자 역할을 한다. 미디어 환경 변화로 디지털 콘텐츠 제작 역량도 요구된다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '언론 관련 전공 + 기자 채용',
    traits: ['호기심', '글쓰기', '정확성', '소통능력'],
  },
  {
    name: '작가',
    category: '미디어·창작',
    summary: '소설·에세이·아동문학 등 창작물을 쓰는 직업',
    description: '출판, 웹소설, 방송 대본 등 다양한 형태의 글을 창작한다. 뛰어난 문장력과 독창성이 필수이며 수입 편차가 크다. 웹소설·웹툰 시장이 커지면서 새로운 창작 기회가 늘고 있다.',
    salary: '연 2,000만~1억원 이상 (성과에 따라 큰 편차)',
    retirementAge: '약 60세 이상 (자유)',
    education: '특별 자격 불요 (문창과 유리)',
    traits: ['창의성', '문장력', '관찰력', '인내심'],
  },
  {
    name: '방송작가',
    category: '미디어·창작',
    summary: '예능·교양·드라마 등 방송 프로그램의 대본과 구성을 쓰는 직업',
    description: '프로그램 기획, 대본 작성, 구성안 제작을 담당한다. 방송사·제작사 소속이거나 프리랜서로 활동하며 아이디어와 집필 능력이 핵심이다. 방송가의 핵심 창작 인력으로 인정받는 직업이다.',
    salary: '연 3,500만~5,500만원',
    retirementAge: '약 60세 (프리랜서는 자유)',
    education: '방송작가 아카데미 + 데뷔',
    traits: ['창의성', '글쓰기', '트렌드감각', '인내심'],
  },
  {
    name: 'PD',
    category: '미디어·창작',
    summary: '방송·영상 콘텐츠의 기획과 제작을 총괄하는 프로듀서',
    description: '프로그램 기획, 촬영·편집 지휘, 출연자 섭외, 예산 관리 등을 총괄한다. 콘텐츠 산업의 성장으로 유튜브·OTT 등 활동 영역이 넓어지고 있다. 뛰어난 기획력과 조직 관리 능력이 요구된다.',
    salary: '연 5,000만~6,500만원',
    retirementAge: '약 60세',
    education: '방송·영상 관련 전공 + 채용',
    traits: ['기획력', '리더십', '창의성', '커뮤니케이션'],
  },
  {
    name: '콘텐츠기획자',
    category: '미디어·창작',
    summary: '웹·모바일·방송 등 다양한 콘텐츠의 기획과 제작을 담당하는 직업',
    description: '콘텐츠 아이디어 발굴, 기획안 작성, 제작 관리, 성과 분석을 담당한다. 트렌드에 대한 감각과 데이터 분석 능력이 중요하며 콘텐츠 산업 전반에서 수요가 높다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '콘텐츠 관련 전공 + 기획 역량',
    traits: ['기획력', '트렌드감각', '창의성', '분석력'],
  },

  // ─── IT·공학 ───
  {
    name: '소프트웨어개발자',
    category: 'IT·공학',
    summary: '프로그램과 애플리케이션을 설계하고 개발하는 IT 전문가',
    description: '웹·앱·시스템 소프트웨어의 설계, 코딩, 테스트, 유지보수를 담당한다. 프로그래밍 능력이 핵심이며 산업 전반에서 수요가 가장 높은 직업 중 하나다. 지속적인 기술 학습이 필요하지만 높은 연봉과 성장 가능성을 갖는다.',
    salary: '연 5,000만~8,000만원',
    retirementAge: '약 60세',
    education: '컴퓨터공학 전공 + 개발 역량',
    traits: ['논리력', '문제해결', '집중력', '자기주도학습'],
  },
  {
    name: 'AI엔지니어',
    category: 'IT·공학',
    summary: '인공지능 모델을 설계·개발하고 서비스에 적용하는 전문가',
    description: '머신러닝·딥러닝 모델 개발, 데이터 처리, AI 서비스 구축을 담당한다. 수학·통계·프로그래밍 역량이 필요하며 AI 시대의 대표적인 고수익 직업으로 각광받고 있다.',
    salary: '연 6,000만~1억원',
    retirementAge: '약 60세',
    education: 'AI·컴퓨터공학 전공 + 머신러닝 역량',
    traits: ['수리력', '논리력', '호기심', '문제해결'],
  },
  {
    name: '데이터과학자',
    category: 'IT·공학',
    summary: '빅데이터를 분석해 인사이트를 도출하고 의사결정을 돕는 전문가',
    description: '데이터 수집·정제·분석·시각화를 통해 비즈니스 문제를 해결한다. 통계·수학·프로그래밍 역량이 필요하며 기업의 데이터 기반 의사결정을 주도하는 핵심 직군이다.',
    salary: '연 6,000만~9,000만원',
    retirementAge: '약 60세',
    education: '통계·데이터과학 전공 + 분석 역량',
    traits: ['분석력', '수리력', '호기심', '논리력'],
  },
  {
    name: '반도체엔지니어',
    category: 'IT·공학',
    summary: '반도체 칩의 설계·공정·테스트를 담당하는 전문 기술자',
    description: '반도체 설계(팹리스)와 제조(파운드리) 전반에서 일하며, 우리나라 핵심 산업의 주역이다. 전자·물리·재료공학 지식이 필요하며 높은 연봉과 안정성을 갖춘 대표적인 전문직이다.',
    salary: '연 6,000만~9,000만원',
    retirementAge: '약 60세',
    education: '전자·반도체공학 전공',
    traits: ['전문성', '정밀함', '문제해결', '끈기'],
  },
  {
    name: '기계공학자',
    category: 'IT·공학',
    summary: '기계·장비·제품의 설계와 제조 기술을 연구하는 엔지니어',
    description: '자동차, 로봇, 항공, 제조 설비 등 다양한 기계의 설계와 해석을 담당한다. 물리·수학적 지식과 설계 도구(CAD) 활용 능력이 필요하며 제조업 전반에서 폭넓게 활약한다.',
    salary: '연 5,000만~7,000만원',
    retirementAge: '약 60세',
    education: '기계공학 전공',
    traits: ['분석력', '문제해결', '정밀함', '창의성'],
  },
  {
    name: '전자공학자',
    category: 'IT·공학',
    summary: '전자 회로와 시스템, 통신 기술을 연구·개발하는 엔지니어',
    description: '반도체, 통신, IoT, 로봇 등 전자 시스템의 설계와 개발을 담당한다. 전자·통신 분야의 핵심 기술 인력으로 산업 전반에서 수요가 높다.',
    salary: '연 5,500만~7,500만원',
    retirementAge: '약 60세',
    education: '전자공학 전공',
    traits: ['논리력', '전문성', '문제해결', '호기심'],
  },

  // ─── 경영·금융 ───
  {
    name: '경영컨설턴트',
    category: '경영·금융',
    summary: '기업의 경영 전략과 조직 문제를 진단하고 해결책을 제시하는 전문가',
    description: '기업의 전략, 조직, 운영, 마케팅 등을 분석해 개선 방안을 제시한다. 뛰어난 분석력과 커뮤니케이션 능력이 필요하며 경영 컨설팅 펌에서 일하거나 프리랜서로 활동한다.',
    salary: '연 6,000만~9,000만원',
    retirementAge: '약 60세',
    education: '경영학 전공 + 컨설팅 경력',
    traits: ['분석력', '논리력', '소통능력', '전략적 사고'],
  },
  {
    name: '마케터',
    category: '경영·금융',
    summary: '제품과 브랜드의 가치를 높이고 고객에게 알리는 전략을 수립하는 직업',
    description: '시장 조사, 브랜드 전략, 디지털 마케팅, 광고 캠페인 등을 담당한다. 데이터 분석과 창의성을 함께 갖춰야 하며 디지털 마케팅 역량이 점점 중요해지고 있다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '경영·광고 관련 전공 + 마케팅 역량',
    traits: ['창의성', '분석력', '트렌드감각', '소통능력'],
  },
  {
    name: '회계사',
    category: '경영·금융',
    summary: '기업의 재무 정보를 검증하고 회계·세무·재무 자문을 제공하는 전문가',
    description: '외부감사, 세무 자문, 재무 컨설팅 등을 담당한다. 공인회계사(CPA) 시험 합격이 필요하며 전문성과 신뢰가 생명인 직업이다. 금융·기업 전반에서 안정적인 수요가 있다.',
    salary: '연 6,000만~9,000만원',
    retirementAge: '약 60세',
    education: '공인회계사(CPA) 자격',
    traits: ['정확성', '분석력', '책임감', '꼼꼼함'],
  },
  {
    name: '금융분석가',
    category: '경영·금융',
    summary: '금융 시장과 기업을 분석해 투자 의사결정을 돕는 전문가',
    description: '주식·채권·파생상품 등 금융 데이터를 분석하고 투자 보고서를 작성한다. 금융·경제 지식과 수리 능력이 필요하며 증권사, 자산운용사 등에서 일한다.',
    salary: '연 6,000만~8,000만원',
    retirementAge: '약 60세',
    education: '경제·경영 전공 + 금융 관련 자격',
    traits: ['분석력', '수리력', '판단력', '집중력'],
  },

  // ─── 교육 ───
  {
    name: '초등학교 교사',
    category: '교육',
    summary: '초등학생의 전인적 성장과 기초 교육을 담당하는 교사',
    description: '국어·수학·사회 등 전 교과를 가르치며 생활 지도와 학급 운영을 담당한다. 교육대학 졸업 후 임용고시 합격이 필요하며 정년이 보장되는 안정적인 직업이다. 아이들을 사랑하는 마음이 가장 중요하다.',
    salary: '연 4,500만~5,500만원',
    retirementAge: '약 62세 (정년)',
    education: '교육대학 졸업 + 초등 임용고시',
    traits: ['배려심', '인내심', '소통능력', '책임감'],
  },
  {
    name: '중등교사',
    category: '교육',
    summary: '중·고등학교에서 교과목을 가르치고 학생을 지도하는 교사',
    description: '국어·영어·수학·체육·미술 등 전공 교과를 가르치며 진로·생활 지도를 담당한다. 사범대 또는 교직 이수 후 임용고시 합격이 필요하다. 교과 전문성과 학생을 이끄는 리더십이 요구된다.',
    salary: '연 4,500만~5,500만원',
    retirementAge: '약 62세 (정년)',
    education: '사범대 졸업 + 중등 임용고시',
    traits: ['교과전문성', '인내심', '소통능력', '리더십'],
  },

  // ─── 심리·상담 ───
  {
    name: '심리상담사',
    category: '심리·상담',
    summary: '내담자의 심리적 어려움을 듣고 상담을 통해 치유를 돕는 전문가',
    description: '개인·집단 상담을 통해 정서적 문제, 관계 갈등, 진로 고민 등을 돕는다. 심리학 관련 학위와 상담 자격이 필요하며 상담센터, 학교, 복지기관 등에서 활동한다.',
    salary: '연 3,500만~5,000만원',
    retirementAge: '약 60세',
    education: '심리학 전공 + 상담 자격',
    traits: ['공감능력', '경청능력', '인내심', '신뢰성'],
  },
  {
    name: '임상심리사',
    category: '심리·상담',
    summary: '심리 평가와 진단, 심리 치료를 담당하는 전문 심리학자',
    description: '심리검사, 심리 평가, 정신건강 상담·치료를 담당한다. 임상심리 관련 석사 이상 학위와 자격이 필요하며 병원, 정신건강센터, 연구소 등에서 일한다.',
    salary: '연 4,000만~5,500만원',
    retirementAge: '약 60세',
    education: '임상심리학 석사 이상 + 자격',
    traits: ['분석력', '공감능력', '전문성', '책임감'],
  },

  // ─── 법률 ───
  {
    name: '변호사',
    category: '법률',
    summary: '법률 상담과 소송 대리, 법적 권리 보호를 담당하는 법률 전문가',
    description: '민사·형사·가사 등 다양한 법률 사건의 상담과 소송 대리를 담당한다. 로스쿨 졸업 후 변호사시험 합격이 필요하며 전문성과 윤리의식이 생명이다. 높은 사회적 지위와 연봉을 갖는 대표적인 전문직이다.',
    salary: '연 8,000만~1억 5,000만원',
    retirementAge: '약 65세',
    education: '로스쿨 졸업 + 변호사시험',
    traits: ['논리력', '설득력', '정확성', '책임감'],
  },
  {
    name: '법무사',
    category: '법률',
    summary: '등기·공증·경매 등 법률 사무를 대행하는 법률 전문가',
    description: '부동산 등기, 공증, 법인 설립, 경매 등의 사무를 대행한다. 법무사 시험 합격이 필요하며 생활 법률 분야에서 안정적인 수요가 있는 전문직이다.',
    salary: '연 5,000만~7,000만원',
    retirementAge: '약 65세',
    education: '법무사 시험 합격',
    traits: ['꼼꼼함', '정확성', '책임감', '신뢰성'],
  },

  // ─── 연구 ───
  {
    name: '연구원',
    category: '연구',
    summary: '특정 분야의 지식을 깊이 연구하고 새로운 발견을 이끌어내는 직업',
    description: '대학, 연구소, 기업 연구소 등에서 기초·응용 연구를 수행한다. 자연과학·공학·인문사회 등 분야가 다양하며 박사 학위가 유리하다. 지적 호기심과 끈기가 핵심인 직업이다.',
    salary: '연 4,500만~6,000만원',
    retirementAge: '약 60~65세',
    education: '석사·박사 학위 + 연구 경력',
    traits: ['호기심', '분석력', '끈기', '논리력'],
  },

  // ─── 디자인 ───
  {
    name: '그래픽디자이너',
    category: '디자인',
    summary: '시각적 커뮤니케이션을 위한 디자인을 창작하는 전문가',
    description: '로고, 포스터, 브랜드, 웹·앱 디자인 등 시각 콘텐츠를 창작한다. 디자인 감각과 도구 활용 능력이 필요하며 프리랜서나 디자인 에이전시에서 활동한다.',
    salary: '연 3,500만~5,000만원',
    retirementAge: '약 60세',
    education: '디자인 전공 + 포트폴리오',
    traits: ['심미안', '창의성', '표현력', '트렌드감각'],
  },
  {
    name: 'UX디자이너',
    category: '디자인',
    summary: '사용자 경험을 연구하고 더 편리한 제품·서비스를 설계하는 전문가',
    description: '사용자 조사, 정보 구조 설계, 프로토타입 제작, 사용성 테스트를 담당한다. 디자인과 심리학, 데이터 분석을 결합한 직업으로 IT 업계에서 수요가 높다.',
    salary: '연 4,500만~6,500만원',
    retirementAge: '약 60세',
    education: '디자인·HCI 전공 + UX 역량',
    traits: ['공감능력', '분석력', '창의성', '논리력'],
  },
];

// 직업 이름 → 상세 정보 빠른 조회용 인덱스
export const jobIndex: Record<string, Job> = Object.fromEntries(
  jobs.map((job) => [job.name, job])
);

// 유사·축약 표현을 정식 직업 이름으로 연결하는 별칭 맵
export const jobAliases: Record<string, string> = {
  '통역가': '통역사',
  '큐레이터': '학예사',
  '미술관 큐레이터': '학예사',
  '박물관 큐레이터': '학예사',
  '스튜어디스': '승무원',
  '스튜어드': '승무원',
  '항공승무원': '승무원',
  '기장': '항공기 기장',
  '부기장': '항공기 기장',
  '운동선수 매니저': '운동선수 매니저',
  '운동선수 에이전트': '운동선수 매니저',
  '미화원': '환경미화원',
  '청소노동자': '환경미화원',
  '자동차정비사': '자동차정비원',
  '정비원': '자동차정비원',
  '버스운전기사': '버스기사',
  '택시운전기사': '택시기사',
  '도슨트': '박물관 안내사',
  '문화해설사': '박물관 안내사',
  '학예연구사': '학예사',
  '가스공사': '가스공사 직원',
  '한국가스공사': '가스공사 직원',
  '환경관리공단': '환경관리공단 직원',
  '한국환경공단': '환경관리공단 직원',
  '한국교통공사': '한국교통공사 직원',
  '철도공무원': '한국교통공사 직원',
  '교통공기업': '한국교통공사 직원',
  '물리치료사': '물리치료사',
  '의사': '의사',
  '내과의': '의사',
  '외과의': '의사',
  '연구의': '의사',
  '의료관리자': '의사',
  '약사': '약사',
  '수의사': '수의사',
  '교사': '중등교사',
  '국어교사': '중등교사',
  '영어교사': '중등교사',
  '수학교사': '중등교사',
  '체육교사': '중등교사',
  '미술교사': '중등교사',
  '윤리교사': '중등교사',
  '국어국문학과': '중등교사',
  '초등교사': '초등학교 교사',
  '방과후교사': '중등교사',
  '교육행정가': '공무원',
  '교육정책전문가': '공무원',
  '교육과정개발자': '연구원',
  '교육학연구원': '연구원',
  '교육연구원': '연구원',
  '교육컨설턴트': '경영컨설턴트',
  '소프트웨어개발자': '소프트웨어개발자',
  '게임개발자': '소프트웨어개발자',
  '시스템엔지니어': '소프트웨어개발자',
  'AI연구원': 'AI엔지니어',
  'AI엔지니어': 'AI엔지니어',
  '머신러닝엔지니어': 'AI엔지니어',
  'AI프로덕트매니저': '콘텐츠기획자',
  '데이터분석가': '데이터과학자',
  '데이터과학자': '데이터과학자',
  '통계학자': '데이터과학자',
  '기계공학자': '기계공학자',
  '자동차공학자': '기계공학자',
  '로봇공학자': '기계공학자',
  '항공우주공학자': '기계공학자',
  '전자공학자': '전자공학자',
  '통신공학자': '전자공학자',
  'IoT전문가': '전자공학자',
  '반도체엔지니어': '반도체엔지니어',
  '물리학자': '연구원',
  '화학자': '연구원',
  '수학자': '연구원',
  '암호학자': '연구원',
  '금융공학자': '금융분석가',
  '생명과학연구원': '연구원',
  '의생명공학자': '연구원',
  '바이오의약품연구원': '연구원',
  '제약연구원': '연구원',
  '임상시험연구원': '연구원',
  '약학교수': '연구원',
  '철학연구원': '연구원',
  '역사학자': '연구원',
  '기록연구사': '연구원',
  '문화재전문가': '학예사',
  '정책연구원': '연구원',
  '정치분석가': '연구원',
  '경제학자': '연구원',
  '경영컨설턴트': '경영컨설턴트',
  '마케터': '마케터',
  '재무분석가': '금융분석가',
  '투자분석가': '금융분석가',
  '금융분석가': '금융분석가',
  '창업가': '경영컨설턴트',
  'CEO': '경영컨설턴트',
  '회계사': '회계사',
  '세무사': '회계사',
  '변호사': '변호사',
  '법무사': '법무사',
  '검사': '변호사',
  '기자': '기자',
  '언론인': '기자',
  '작가': '작가',
  '출판편집자': '콘텐츠기획자',
  '카피라이터': '콘텐츠기획자',
  '방송작가': '방송작가',
  '웹툰작가': '작가',
  'PD': 'PD',
  '영상제작자': 'PD',
  '영상디자이너': '그래픽디자이너',
  '그래픽디자이너': '그래픽디자이너',
  'UX디자이너': 'UX디자이너',
  '브랜드디자이너': '그래픽디자이너',
  '번역가': '번역가',
  '통역사': '통역사',
  '동시통역사': '동시통역사',
  '외교관': '외교관',
  '대사관직원': '외교관',
  '국제기구직원': '외교관',
  '글로벌기업직원': '번역가',
  '무역전문가': '금융분석가',
  'NGO활동가': '공무원',
  '심리상담사': '심리상담사',
  '임상심리사': '임상심리사',
  '산업심리전문가': '심리상담사',
  '상담사': '심리상담사',
  '소방공무원': '소방공무원',
  '경찰공무원': '경찰공무원',
  '공무원': '공무원',
  '스포츠코치': '스포츠코치',
  '운동처방사': '운동처방사',
  '스포츠행정가': '공무원',
  '미술치료사': '미술치료사',
  '문화예술교육사': '박물관 안내사',
  '간호사': '간호사',
  '물리치료사': '물리치료사',
  '바리스타': '바리스타',
  '제빵사': '제빵사',
  '요리사': '요리사',
  '판매업 종사자': '판매업 종사자',
  '환경미화원': '환경미화원',
  '전기기사': '전기기사',
  '승무원': '승무원',
  '철도기관사': '철도기관사',
  '항공기 기장': '항공기 기장',
  '운동선수': '운동선수',
  '미술관 관리자': '미술관 관리자',
  '박물관 관리자': '박물관 관리자',
  '박물관 안내사': '박물관 안내사',
};

// 이름으로 직업 상세 정보를 조회 (별칭 자동 해석)
export function findJob(name: string): Job | undefined {
  const canonical = jobAliases[name] || name;
  return jobIndex[canonical] || jobIndex[name];
}